import { server } from '../config';
import { env, getContractTypeVal, getCookie, getProjectId, trackUserType } from '../lib/common';
import { getClickTrackersInfo } from './faq';

export const GetBusinesses = async (docId = '') => {
  try {
    const result = await fetch(`${server.apiURL}csportal/getBusinesses?docId=${docId}`, {
      credentials: 'include',
    });
    return result.json();
  } catch (err) {
    const obj = {};
    return obj;
  }
};

export const GetUserDetails = async () => {
  try {
    const result = await fetch(`${server.apiURL}csportal/userDetails`, {
      credentials: 'include',
    });
    return result.json();
  } catch (err) {
    const obj = {};
    return obj;
  }
};

export const GetOptions = async (selectedType, docId, parentId, city, source, shortUrl) => {
  const result = await fetch(
    `${
      server.apiURL
    }csportal/getOptions?ptype=${selectedType}&docId=${docId}&parentId=${parentId}&city=${city}&backUrl=${encodeURI(
      window.location.href,
    )}&source=${source}&shortUrl=${shortUrl}`,
    {
      credentials: 'include',
    },
  );
  const response = await result.json();
  if (!response || (response.errorCode && response.errorCode === 1)) {
    return null;
  }
  return response.result;
};

export const generateLeads = async (paramsData) => {
  try {
    const url = `${server.apiURL}csportal/generateLeads`;
    const options = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        credentials: 'include',
      },
      body: JSON.stringify(paramsData),
    };
    const result = await fetch(url, options);
    const response = await result.json();
    if (!response || (response.errorCode && response.errorCode === 1)) {
      return null;
    }
    return response.result;
  } catch (err) {
    console.log(err);
    return {};
  }
};

export const GetTickets = async (params) => {
  try {
    const ticktId = params.search.ticketId || params.ticketId || '';
    const ordId = params.search.orderId || '';
    const docid = params.search.docId || '';
    const creatdBy = params.search.createdBy || '';
    const strtDate = params.search.strtDate || params.sdt || '';
    const endDt = params.search.endDt || params.edt || '';
    const src = params.search.src || '';
    const srcMob = params.search.src_mob || params.src_mob || '';
    const srcType = params.search.src_typ || '';
    const email = params.search.email_from || '';
    let emailticket = params.emails || '';
    let paidStatus = '';
    if (params.search.paidStatus === 'PAID') {
      paidStatus = '1';
    } else if (params.search.paidStatus === 'NON-PAID') {
      paidStatus = '0';
    }
    let stuts = params.search.stuts || '';
    let status = params._status || '';
    const empId = docid || email ? '' : params.allocEmpid;
    const sort = JSON.stringify({ ...params.sortBy }) || '';
    // for fulfillment filtering status on status not disposition.
    if (params.category === 'FULFILLMENT' || stuts === 'OPEN') {
      status = stuts;
      stuts = '';
    }
    let pkgPri = '';
    if (params.search.package && params.search.package !== '') {
      pkgPri = params.search.package === 'Priority1' ? 1 : 2;
    }
    const issue = params.search.Issue || '';
    const subissue = params.search.subIssue || '';
    const team = params.search.team || '';
    stuts = params.search.disposition || params.search.status ? '' : stuts;
    status = params.search.status || status;
    const city = params.search.email === 1 ? '' : params.search.city || '';
    const role = window.localStorage.getItem('role') || '';
    const cdocId = (params.search.cdocId && params.search.cdocId) || '';
    if (srcType) {
      emailticket = '';
    }
    let url = '';
    if (status === 'In Progress') status = 'INPROGRESS';
    if (params.portalFlag === 1) {
      url = `${server.apiURL}${
        params?.projectId === 'genio' ? 'genio/ticketsHistory' : 'csportal/ticket'
      }?category=${params.category || ''}&vertical=${params.vertical || ''}&team=${team}&alloc_empid=&limit=${
        params.limit || '5'
      }&page=${
        params.page || 1
      }&orderid=&docid=${docid}&ticket_id=${ticktId}&mob=${creatdBy}&sdt=${strtDate}&edt=${endDt}&disposition=&sort=&ticket_creator=&status=${
        !['Grievance Redressal', 'All'].includes(status) ? status.toUpperCase() : ''
      }&download=0&issue_type=&sub_issue_type=&city=&src=&src_typ=${srcType}&paid_status=&email_from=&emails=2&cr_on=-1&csportal=1&genioMyTicketsFlag=${
        params.genioMyTicketsFlag
      }&src_mob=${srcMob}`;
    } else {
      url = `${server.apiURL}wrapper/ticket?category=${params.category || ''}&vertical=${
        params.vertical || ''
      }&alloc_empid=${empId}&limit=${params.limit || '5'}&page=${
        params.page || 0
      }&orderid=${ordId}&docid=${docid}&ticket_id=${ticktId}&mob=${creatdBy}&sdt=${strtDate}&edt=${endDt}&disposition=${stuts}&sort=${sort}&ticket_creator=${
        params.ticketCreator || ''
      }&status=${status}&download=${
        params.download || 0
      }&issue_type=${issue}&sub_issue_type=${subissue}&city=${city}&src=${src}&src_typ=${srcType}&paid_status=${paidStatus}&email_from=${email}&emails=${emailticket}&role=${role}&team=${team}&gr_raised=${
        params.grEligible || ''
      }&pkg_pri=${pkgPri}&cdocId=${cdocId}`;
    }

    if (params?.portalFlag === 1 && status === 'Grievance Redressal' && params?.gr_raised) {
      url += '&gr_raised=1';
    }
    const response = await fetch(url, { credentials: 'include' });
    const data = await response.json();
    return data?.result || {};
  } catch (err) {
    console.log('err in GetTickets: ', err);
    return {};
  }
};

export const getNonLoginOptions = async (type) => {
  try {
    const url = `${server.apiURL}csportal/getNonLoginOptions?type=${type}`;
    const result = await fetch(url, {
      credentials: 'include',
    });
    const response = await result.json();
    if (!response || (response.errorCode && response.errorCode === 1)) {
      return null;
    }
    return response.result;
  } catch (err) {
    console.log(err);
    return {};
  }
};

export const UserFeedbackTicketSubmit = async (name, mobile, email, city, feedbacktype, module, comment, optFlag) => {
  const url = `${server.apiURL}csportal/userTicket
      `;
  const data = {
    name,
    mobile,
    email,
    city,
    feedbacktype,
    module,
    comment,
  };
  if (optFlag) {
    data.optFlag = optFlag;
  }
  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      credentials: 'include',
    },
    body: JSON.stringify(data),
  };
  const fetchResponse = await fetch(url, options);
  const response = await fetchResponse.json();
  const responseData = response;
  return responseData;
};

export const ReOpenTicketSubmit = async (paramsBody) => {
  const url = `${server.apiURL}csportal/updateTicket`;
  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      credentials: 'include',
    },
    body: JSON.stringify(paramsBody),
  };
  const fetchResponse = await fetch(url, options);
  const response = await fetchResponse.json();
  const responseData = response;
  return responseData;
};

export const GetTicketDetails = async (ticketId, projectId) => {
  const result = await fetch(`${server.apiURL}${projectId}/getTicketLogs?ticket_id=${ticketId}`, {
    credentials: 'include',
  });
  return result.json();
};

export const handleImpressionsTrack = async (
  liVal = '',
  liTrd = '',
  faqTypeVal = '',
  othersData = [],
  llTrd = '',
  authState = {},
  llTrdInside = '',
) => {
  const { selectedBusiness, sidResponse, userDetails } = authState;
  const projectIdVal = getProjectId();
  const contractType = getContractTypeVal(projectIdVal);
  try {
    let sessionId = getCookie('session_id');
    if (!sessionId) {
      sessionStorage.setItem('session_id', sessionId);
    }
    if (!sessionId) {
      sessionId = Math.random().toString(36).slice(2);
      document.cookie = `session_id=${sessionId}; path=/;`;
      sessionStorage.setItem('session_id', sessionId);
    }
    if (sessionId) {
      const jduId = userDetails?.jduid || '';
      const sectionOthersData = othersData?.map((item) => item.title);

      const trdObj = {
        cname: selectedBusiness?.compname || '',
        cta_name: '',
        docid: selectedBusiness?.docid || '',
        city: selectedBusiness?.city || '',
        dcity: selectedBusiness?.data_city || '',
        area: selectedBusiness?.areaname || '',
        pin: selectedBusiness?.pincode || '',
        ds: '',
        pdg: '',
        paid: selectedBusiness?.paidstatus || '',
        usertype: sidResponse ? `${trackUserType?.[contractType]}` : 'non_login',
        jd_verified: '',
        guarantee: '',
        trust: '',
        verified: '',
        tag: '',
        pos: '',
        li: liTrd,
        sections: [],
      };

      if (llTrdInside) {
        trdObj.ll = llTrdInside;
      }
      if (liTrd === 'landing') {
        trdObj.sections = [];
        trdObj.cta_name = ['Chat with Us', 'Get a Callback'];
      }
      if (liVal === 'click') {
        trdObj.sections = faqTypeVal === 'Others' ? sectionOthersData : '';
        trdObj.cta_name = '';
      }

      const paramsData = {
        session_id: sessionId,
        search_id: sessionId,
        trd: [trdObj],
        li: liVal,
        ll: llTrd || 'cshmpg',
        referrer: 'auto',
        user_ip: '',
        city: selectedBusiness?.city || '',
        data_city: selectedBusiness?.data_city || '',
        area: selectedBusiness?.areaname || '',
        pincode: selectedBusiness?.pincode || '',
        jduid: jduId || '',
        mobile: authState?.userDetails?.mobile || '',
        request_time: '',
        device_src: getCookie('device_src') || '2',
        device_id: '',
        category_name: '',
        user_agent: '',
        sid: getCookie('sid') || '',
        jde: '',
        vid: '615',
        env,
        utm_source: '',
        utm_medium: '',
        utm_campaign: '',
        app_version: '',
        transaction_id: '',
      };
      await getClickTrackersInfo(paramsData);
    }
  } catch (err) {
    console.log('ERROR in handleClickTrackers', err);
  }
};

export const getCheckDetails = async (paramsData) => {
  const url = `${server.apiURL}csportal/getCheckDetails`;
  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      credentials: 'include',
    },
    body: JSON.stringify(paramsData),
  };
  const result = await fetch(url, options);
  return result.json();
};

export const fetchKycDetails = async (paramsBody) => {
  const url = `${server.apiURL}csportal/getKycDetails`;
  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      credentials: 'include',
    },
    body: JSON.stringify(paramsBody),
  };
  const fetchResponse = await fetch(url, options);
  const response = await fetchResponse.json();
  const responseData = response;
  return responseData;
};